module.exports = __webpack_public_path__ + "img/module1_icon3.9dc2ec3e.png";